<template>
  <div>
    <input v-model="username" type="text" placeholder="Benutzername" @keydown.enter="login" autofocus />
    <input v-model="password" type="password" placeholder="Passwort" @keydown.enter="login" />
    <button type="button" @click="login" :disabled="isLoggingIn">Login</button>
    <div class="login-error">{{ loginErrorMessage }}</div>
    <LoadingSpinner v-if="isLoggingIn"></LoadingSpinner>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import LoadingSpinner from '../../parts/LoadingSpinner'
  import rest from '../../../services/rest'

  export default {
    name: 'Login',
    components: {
      LoadingSpinner
    },
    data () {
      return {
        username: '',
        password: '',
        loginErrorMessage: '',
        isLoggingIn: false
      }
    },
    computed: {
      ...mapGetters({
        isLoggedIn: 'auth/isLoggedIn'
      })
    },
    methods: {
      login () {
        this.loginErrorMessage = ''
        if (!this.username || !this.password) {
          this.loginErrorMessage = 'Bitte geben Sie Benutzernamen und Passwort an.'
          return
        }

        this.isLoggingIn = true
        rest.auth.login(this.username, this.password, (response, hasError) => {
          if (hasError) {
            this.loginErrorMessage = 'Beim Login ist ein Fehler aufgetreten. Bitte prüfen Sie Benutzernamen und Passwort.'
            this.isLoggingIn = false
            return
          }

          this.$store.commit('auth/LOGIN', response.body)
          this.$router.push({ name: 'AdminSlides' })
          this.isLoggingIn = false
        })
      }
    },
    mounted () {
      if (this.isLoggedIn) {
        this.$router.push({ name: 'AdminSlides' })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .login-error {
    font-size: 18pt;
    color: red;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?e02652f2